// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './ItemListImage.css';

// Components
import { ProgressiveImageLoader } from '../../common';

type Props = {
  variant: any,
  isBlend?: boolean,
  disableLink?: boolean,
};

class ItemListImage extends Component {
  props: Props;
  render() {
    const image = (
      <ProgressiveImageLoader
        selectedImage={this.props.variant.images[0]}
        imageToShow={'large'}
      />
    );

    return (
      <div className="image-list-control">
        <div className="image-list-main">
          {this.props.disableLink ? (
            image
          ) : (
            <Link
              to={
                this.props.isBlend
                  ? '/blend/meus-blends/'
                  : `/produtos/${this.props.variant.slug}/`
              }
            >
              {image}
            </Link>
          )}
        </div>
      </div>
    );
  }
}

export default ItemListImage;
